import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import { RecipeToPackageTypeEditDialog } from '../../Dialogs/Configuration/RecipeToPackageTypeEditDialog';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function RecipeToPackageTypeTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getPackageTypes = async function () {
            let url = `api/v1/recipeToPackageType/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getPackageTypes();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Material Code',
            accessor: 'materialCode',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'Recipe',
            accessor: 'recipeName',
            filter: 'includesString',
        },
        {
            Header: 'Package Type',
            accessor: 'packageTypeName',
            filter: 'includesString',
        },
        {
            Header: 'Is Default',
            accessor: 'isDefault',
            filter: 'includesString',
            Cell: (props) => <div>{props.value ? "Yes" : ""}</div>
        },

    ];

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}


function RecipeToPackageType() {
    const getNewRecipeToPackageType = () => {
        return {id:null, materialCode:"", recipeId:0, packageTypeId:0}
    }

    return (
        <CommonConfigPage
            title={"Recipe To Package Type"}
            Table={RecipeToPackageTypeTable}
            Dialog={RecipeToPackageTypeEditDialog}
            getNewConfigObject={getNewRecipeToPackageType}
        />
    );
}

export default RecipeToPackageType;